const joinValues = (...values: string[]): string => values.join(' / ');

const parseJsonArray = (arrayData: any): any[] => JSON.parse(arrayData);

const buildTableArray = (
  jsonObj: any[],
  parseCell: (cell: any, key: string, key2: string) => any[]
): any[] =>
  jsonObj.map((element) => {
    const newArrayData: any[] = [];
    const iter = element.table;

    for (const key in iter) {
      const myObjArray: any[] = [];

      for (const key2 in iter[key]) {
        myObjArray.push(...parseCell(iter[key][key2], key, key2));
      }

      newArrayData.push(myObjArray);
    }

    return { table: newArrayData };
  });

const parseAuditCell = (cell: any, key2: string): any[] => {
  if (key2 === '5') {
    return [{ text: joinValues(cell.tooltip[1].paragraph, cell.tooltip[3].paragraph) }];
  }

  if (key2 === '7') {
    return [{
      text: joinValues(
        cell.tooltip[1].paragraph,
        cell.tooltip[3].paragraph,
        cell.tooltip[5].paragraph
      ),
    }];
  }

  return [cell];
};

const parseHomeTrainCell = (cell: any): any[] => [
  {
    text: joinValues(
      cell.tooltip[1].paragraph,
      cell.tooltip[3].paragraph,
      cell.tooltip[5].paragraph
    ),
  },
];

const parseHomeInstructorCell = (cell: any): any[] => {
  const instructor = cell.text;

  if (cell?.tooltip !== undefined) {
    return [{ text: joinValues(instructor, cell.tooltip[1].paragraph) }];
  }

  return [{ text: instructor || '-' }];
};

const parseHomeUserInfoCell = (cell: any): any[] => {
  if (cell?.tooltip !== undefined && cell?.text !== undefined) {
    const alumn = cell?.text || '';
    const observations = cell?.tooltip[1]?.paragraph || '';

    return [{ text: joinValues(alumn, observations) }];
  }

  return [];
};

const parseHomeCell = (
  cell: any,
  key2: string,
  canSeeUserInfo: boolean
): any[] => {
  if (key2 === '6') {
    return parseHomeTrainCell(cell);
  }

  if (key2 === '7') {
    return parseHomeInstructorCell(cell);
  }

  if (canSeeUserInfo && key2 === '8') {
    return parseHomeUserInfoCell(cell);
  }

  return [cell];
};

const parseReportHoursCell = (cell: any, key: string, key2: string): any[] => {
  if (key2 === '5' && Object.prototype.hasOwnProperty.call(cell, 'tooltip')) {
    return [
      cell,
      {
        text: cell.tooltip[1].paragraph,
        className: 'position_icon test-class-name',
      },
    ];
  }

  if (key === '5') {
    return [
      cell,
      {
        text: 'No hay días con exceso',
      },
    ];
  }

  return [cell];
};

export function parseArrayData(
  arrayData: any,
  isHome: boolean = false,
  canSeeUserInfo: boolean = false
) {
  const jsonObj = parseJsonArray(arrayData);

  const tableArrayData = buildTableArray(jsonObj, (cell, _key, key2) =>
    isHome
      ? parseHomeCell(cell, key2, canSeeUserInfo)
      : parseAuditCell(cell, key2)
  );

  return JSON.stringify(tableArrayData);
}

export function parseReportHoursData(arrayData: any) {
  const jsonObj = parseJsonArray(arrayData);

  const tableArrayData = buildTableArray(jsonObj, (cell, key, key2) =>
    parseReportHoursCell(cell, key, key2)
  );

  return JSON.stringify(tableArrayData);
}

export function instructorHoursHeaders(headers: any) {
  const newHeaders: any[] = [...headers];
  newHeaders.push({ text: 'Días con exceso en cálculo de jornada (8h)' });
  return newHeaders;
}
